import { helper } from '@ember/component/helper';

import { isArray } from '@ember/array';
import { warn } from '@ember/debug';

export default helper(function joinKeysHelper([ objects, key, delimiter = ', ' ]) {
  if (typeof objects === 'string' || typeof objects === 'number') {
    warn(
      `join-keys helper passed non-array value '${objects}'.`,
      false,
      { id: `join-keys_${objects}_${key}` }
    );
    return objects;
  }
  if (!isArray(objects) || !objects.length
    || (!key && key !== 0 && key !== '')
  ) {
    return '';
  }
  return objects
    // Using map, because arrays don't have mapBy...
    .map(object => object[key])
    // Using reduce, because EmberArrays don't have join
    .reduce((text, value, i) =>
      text + (i ? delimiter : '') + (value || ''),
    '');
});
